import { render, staticRenderFns } from "./RewardListComponent.vue?vue&type=template&id=263e5527&scoped=true"
import script from "./RewardListComponent.vue?vue&type=script&lang=js"
export * from "./RewardListComponent.vue?vue&type=script&lang=js"
import style0 from "./RewardListComponent.vue?vue&type=style&index=0&id=263e5527&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "263e5527",
  null
  
)

export default component.exports